import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9tauvjpv18futdmiapg';

const testimonials = [
  {
    name: '小樱',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20smiling%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=testimonial-01&orientation=squarish',
    comment: '自从发现了少女领域，每天穿搭都有了新灵感！特别是春季穿搭指南那篇，照着搭真的超好看，同事都在问我衣服哪里买的~',
    role: '忠实读者 · 2年',
  },
  {
    name: '蜜桃',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20peach%20color%20hair%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=testimonial-02&orientation=squarish',
    comment: '化妆教程真的对新手太友好了！五步日常妆我现在每天出门前必看，从手残党到能化出自然妆，超级有成就感！',
    role: '美妆爱好者 · 1年',
  },
  {
    name: '草莓',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20red%20hair%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=testimonial-03&orientation=squarish',
    comment: '按照房间布置那篇文章重新装饰了我的小窝，朋友们都说像童话一样！手账教程也超实用，现在每天都坚持写手账~',
    role: '生活达人 · 1年',
  },
];

const faqs = [
  {
    q: '少女领域是什么？',
    a: '少女领域是一个专注少女风格的时尚、美妆、生活方式与兴趣内容的垂直平台。我们致力于为每一位少女提供穿搭灵感、美妆教程、好物推荐和社群交流，打造属于少女们的专属精神乐园。',
  },
  {
    q: '如何加入少女社群？',
    a: '你可以在我们首页底部的订阅区域输入邮箱，订阅少女日报获取最新内容。同时我们也活跃在微博、小红书、抖音和B站等平台，搜索"少女领域"就能找到我们！',
  },
  {
    q: '可以投稿或合作吗？',
    a: '当然可以！我们非常欢迎优秀的创作者和品牌合作。请通过本页面的联系表单发送你的合作意向，我们的编辑团队会在3个工作日内回复你。',
  },
  {
    q: '网站内容多久更新一次？',
    a: '我们每周至少更新3-5篇原创内容，涵盖穿搭、美妆、生活等各个板块。订阅少女日报，每周五会推送一周精选内容合集到你的邮箱~',
  },
  {
    q: '如何取消订阅？',
    a: '每封少女日报的底部都有取消订阅的链接，点击即可一键退订。我们尊重每一位读者的选择，来去自由~',
  },
];

export default function AboutPage() {
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [contactError, setContactError] = useState('');
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  useEffect(() => {
    window.scrollTo(0, 0);

    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash.replace('#', ''));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, []);

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setContactError('');

    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setContactError('请填写所有必填项哦~');
      return;
    }

    if (formData.message.length > 500) {
      setContactError('留言内容不能超过500字哦~');
      return;
    }

    const formEl = e.currentTarget as HTMLFormElement;
    const fd = new FormData(formEl);
    const honeypot = fd.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setContactSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
      return;
    }
    fd.delete('phone_alt');

    try {
      const params = new URLSearchParams();
      fd.forEach((v, k) => {
        params.append(k, String(v));
      });

      const res = await fetch(CONTACT_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const text = await res.text();
      if (res.ok) {
        setContactSubmitted(true);
        setFormData({ name: '', email: '', message: '' });
      } else {
        setContactError('提交出错了，请稍后再试~');
      }
    } catch {
      setContactError('网络出错了，请稍后再试~');
    }
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Page Header */}
        <section className="relative w-full h-[260px] md:h-[320px] overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage:
                'url(https://readdy.ai/api/search-image?query=soft%20pink%20rose%20garden%20with%20morning%20dew%20and%20gentle%20sunlight%2C%20dreamy%20romantic%20atmosphere%2C%20elegant%20feminine%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20warm%20delicate%20tone&width=1800&height=600&seq=about-header-01&orientation=landscape)',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/45"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="container-custom pb-10">
              <nav className="mb-3" aria-label="面包屑导航">
                <ol className="flex items-center gap-2 text-xs text-white/70">
                  <li>
                    <Link to="/" className="hover:text-white transition-colors cursor-pointer">
                      首页
                    </Link>
                  </li>
                  <li className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </li>
                  <li className="text-white">关于我们</li>
                </ol>
              </nav>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-white">
                关于我们
              </h1>
              <p className="mt-2 text-sm md:text-base text-white/70 max-w-xl">
                了解少女领域的故事与初心
              </p>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
                品牌故事
              </h2>
              <div className="mt-10 space-y-6">
                <p className="text-base leading-relaxed text-foreground-700">
                  少女领域诞生于2024年的春天，由一群热爱生活、热爱分享的少女创立。我们相信，每一位少女都有独特的光芒，都值得拥有属于自己的梦幻世界。
                </p>
                <p className="text-base leading-relaxed text-foreground-700">
                  在这个信息爆炸的时代，少女们面临着各种各样的选择和困惑——今天穿什么？如何化一个自然又好看的日常妆？怎样把房间布置得温馨又好看？去哪里找到志同道合的朋友？
                </p>
                <p className="text-base leading-relaxed text-foreground-700">
                  少女领域的创立，就是为了回答这些问题。我们汇聚了来自全国各地的少女创作者，她们用自己的真实经验和热情，分享穿搭灵感、美妆技巧、生活美学和兴趣探索。这里不贩卖焦虑，只传递美好。
                </p>
                <p className="text-base leading-relaxed text-foreground-700">
                  我们希望少女领域不仅仅是一个内容平台，更是一个温暖的少女社群。在这里，你可以自由地探索自己的兴趣，找到属于自己的风格，结识志同道合的闺蜜。让每一个少女，都能在这里找到归属感，让青春和梦想自由绽放。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="container-custom">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
              {[
                { number: '370+', label: '原创文章' },
                { number: '12万+', label: '忠实读者' },
                { number: '50+', label: '合作品牌' },
                { number: '4个', label: '内容板块' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.number}</p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section id="reputation" className="py-14 md:py-20 bg-background-50">
          <div className="container-custom">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                用户口碑
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
                来自少女们的真实反馈，是我们前行的最大动力~
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-100 rounded-lg p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <div className="flex gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.comment}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section id="contact" className="py-14 md:py-20 bg-background-100">
          <div className="container-custom">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  联系我们
                </h2>
                <p className="mt-3 text-sm md:text-base text-foreground-500">
                  有任何问题、建议或合作意向，随时和我们聊聊吧~
                </p>
              </div>

              {contactSubmitted ? (
                <div className="bg-background-50 rounded-lg p-10 text-center">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                    <i className="ri-check-line text-2xl"></i>
                  </div>
                  <h3 className="mt-4 text-lg font-heading font-bold text-foreground-900">提交成功！</h3>
                  <p className="mt-2 text-sm text-foreground-500">
                    感谢你的留言，我们会在3个工作日内回复你~
                  </p>
                </div>
              ) : (
                <form
                  className="bg-background-50 rounded-lg p-8"
                  onSubmit={handleContactSubmit}
                  id="contact-form"
                  data-readdy-form="true"
                >
                  <div className="website-alt-wrapper">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-2">
                        你的名字 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="contact-name"
                        name="name"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        placeholder="怎么称呼你呢？"
                        className="w-full px-4 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-2">
                        邮箱地址 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="contact-email"
                        name="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="example@email.com"
                        className="w-full px-4 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-5">
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-2">
                      留言内容 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      rows={5}
                      maxLength={500}
                      placeholder="写下你想说的话吧~（最多500字）"
                      className="w-full px-4 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      required
                    ></textarea>
                    <p className="mt-1 text-xs text-foreground-400 text-right">
                      {formData.message.length}/500
                    </p>
                  </div>
                  {contactError && (
                    <p className="mb-4 text-sm text-primary-600">{contactError}</p>
                  )}
                  <button
                    type="submit"
                    className="w-full py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    发送留言
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="py-14 md:py-20 bg-background-50">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  常见问题
                </h2>
                <p className="mt-3 text-sm md:text-base text-foreground-500">
                  你可能想知道的都在这里~
                </p>
              </div>
              <div className="space-y-4">
                {faqs.map((faq, idx) => (
                  <details key={idx} className="group bg-background-100 rounded-lg overflow-hidden">
                    <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                      <span className="text-sm md:text-base font-medium text-foreground-800">{faq.q}</span>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-4">
                        <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform text-lg"></i>
                      </div>
                    </summary>
                    <div className="px-6 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'BreadcrumbList',
                '@id': 'https://ruilongguoyao.cn/about/#breadcrumb',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://ruilongguoyao.cn/',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: '关于我们',
                    item: 'https://ruilongguoyao.cn/about/',
                  },
                ],
              },
              {
                '@type': 'AboutPage',
                '@id': 'https://ruilongguoyao.cn/about/#about',
                url: 'https://ruilongguoyao.cn/about/',
                name: '关于少女领域',
                description: '了解少女领域的品牌故事、用户口碑和联系方式',
                isPartOf: {
                  '@id': 'https://ruilongguoyao.cn/#website',
                },
                about: {
                  '@id': 'https://ruilongguoyao.cn/#organization',
                },
                inLanguage: 'zh-CN',
              },
              {
                '@type': 'FAQPage',
                '@id': 'https://ruilongguoyao.cn/about/#faq',
                mainEntity: faqs.map((faq) => ({
                  '@type': 'Question',
                  name: faq.q,
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.a,
                  },
                })),
              },
            ],
          }),
        }}
      />
    </>
  );
}